module.exports = __webpack_public_path__ + "static/media/sort_up.4ef17267.svg";